// Messages Vite and the browsers it runs in produce when a lazily loaded chunk
// no longer exists, which happens when a deploy changes the content hash while
// a tab stays open. Kept free of imports so plugins/vue-sentry.js can use it
// without pulling i18n or the snackbar service into its import graph.

const CHUNK_LOAD_ERROR_PATTERNS = [
    /Failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
    /Importing a module script failed/i,
    /Unable to preload CSS/i,
];

export function isChunkLoadError(error) {
    const message = typeof error === 'string' ? error : (error?.message ?? '');

    return CHUNK_LOAD_ERROR_PATTERNS.some(pattern => pattern.test(message));
}
